export const yellow = '#ffce21'
export const lightBlue = '#a4c2d5'
export const darkBlue = '#121f42'
export const lightTheme = {
  body: '#fff',
  background: lightBlue,
  text: '#333',
  primary: darkBlue,
  secondary: yellow,
  tertiary: '#333',
  toggleBorder: yellow,
  textContrast: '#fff'
}

export const darkTheme = {
  body: '#333',
  background: '#666',
  text: '#fff',
  primary: '#064663',
  secondary: '#ECB365',
  tertiary: '#fff',
  toggleBorder: yellow,
  textContrast: '#fff'
}
